import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"
import { FormsModule } from "@angular/forms"
import { MatButtonModule } from "@angular/material/button"
import { MatButtonToggleModule } from "@angular/material/button-toggle"
import { MatCheckboxModule } from "@angular/material/checkbox"
import { MatDatepickerModule } from "@angular/material/datepicker"
import { MatDialogModule } from "@angular/material/dialog"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { MatListModule } from "@angular/material/list"
import { MatPaginatorModule } from "@angular/material/paginator"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import { MatSelectModule } from "@angular/material/select"
import { MatSortModule } from "@angular/material/sort"
import { MatTableModule } from "@angular/material/table"
import { MatTooltipModule } from "@angular/material/tooltip"
import { TrCustomizableColumnsComponent } from "./tr-customizable-columns/tr-customizable-columns.component"
import { TrFilterDialogComponent } from "./tr-filter-dialog/tr-filter-dialog.component"
import { TrFilterHeaderComponent } from "./tr-filter-header/tr-filter-header.component"
import { TrTableGlobalFilterModalDirective } from "./tr-table-global-filter-modal.directive"
import { TrTableComponent } from "./tr-table.component"

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatListModule,
    MatTooltipModule,
  ],
  declarations: [
    TrTableComponent,
    TrFilterHeaderComponent,
    TrFilterDialogComponent,
    TrTableGlobalFilterModalDirective,
    TrCustomizableColumnsComponent,
  ],
  entryComponents: [
    TrFilterDialogComponent,
    TrCustomizableColumnsComponent,
  ],
  exports: [
    TrTableComponent,
    TrFilterHeaderComponent,
    TrFilterDialogComponent,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
  ],
})
export class TrTableModule { }
